import { frontendURL } from 'dashboard/helper/URLHelper';
import CommercialOffersIndex from './pages/CommercialOffersIndex.vue';

const commercialOffersRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/commercial-offers'),
      name: 'commercial_offers_index',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: CommercialOffersIndex,
    },
  ],
};

export default commercialOffersRoutes;
